import React from 'react'

import AlertDialog from './Dialog'

const AlertDialogHOC = PassedComponent => {
  class ParentAlertDialog extends React.Component {
    constructor(props) {
      super(props)
      this.state = {
        isOpen: false,
      }
    }

    handleClickOpen = () => {
      this.setState({ isOpen: true })
    }

    handleClose = () => {
      this.setState({ isOpen: false })
    }

    render() {
      const newProps = {
        confirmModal: {
          open: this.handleClickOpen,
          onClose: this.handleClose,
        },
      }
      const modalProps = {
        isOpen: this.state.isOpen,
        isClose: this.handleClose,
      }
      return (
        <div>
          <PassedComponent {...newProps} />
          <AlertDialog {...modalProps} />
        </div>
      )
    }
  }
  return ParentAlertDialog
}

export default AlertDialogHOC
